import { all, call, put, takeLeading } from 'redux-saga/effects';

import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';
import {
  updateSurvey,
  updateSurveyFailure,
  updateSurveySuccess,
} from '@app/store/account/survey/actions';
import { ACCOUNT_SURVEY_UPDATE_REQUEST } from '@app/store/actionTypes';
import { modalOpen } from '@app/store/modal/actions';
import { putSurvey } from '@app/store/transport-layer/identityaccess/survey';

export function* updateSurveySaga({
  payload: { category, department, name, phoneNumber, scale, type },
}: ReturnType<typeof updateSurvey>) {
  let survey: {
    companyCategory?: string;
    companyName?: string;
    companyScale?: string;
    department?: string;
    phoneNumber: string;
    userType: string;
  } = { phoneNumber, userType: type };

  if (!(type === '개인' || type === '개인이용자')) {
    survey = {
      ...survey,
      companyCategory: category,
      companyName: name,
      companyScale: scale,
      department,
    };
  }
  /* eslint-enable camelcase */

  const SURVEY_UPDATE_RESPONSE: { [key: string]: string } = {
    'user not found': '존재하지 않는 유저입니다.',
  };

  try {
    yield call(putSurvey, survey);
    yield put(
      modalOpen('CONFIRM', {
        content: '새로운 상세정보가 저장되었습니다.',
      })
    );
    yield put(updateSurveySuccess());
  } catch (error) {
    yield put(
      modalOpen('CONFIRM', {
        content:
          SURVEY_UPDATE_RESPONSE[error.message] ||
          GLOBAL_ERROR_MESSAGE[error.message] ||
          error.message,
      })
    );
    yield put(updateSurveyFailure(error));
  }
}

export default function* saga() {
  yield all([takeLeading(ACCOUNT_SURVEY_UPDATE_REQUEST, updateSurveySaga)]);
}
